import { type FC, type ReactElement, useState } from "react";
import { useTranslation } from "react-i18next";
import { AdditionalServicesCarousel } from "../../../modules/additional-services/additional-services-carousel";
import { CreateAIContentCarousel } from "../../../modules/assets/create-ai-content-carousel";
import { Page } from "../../../modules/layout/components/page";
import { PageContent } from "../../../modules/layout/components/page-content";
import {
  type MomentCardMomentActivity,
  SupabaseMomentsRecentlyEditedService,
  SupabaseMomentsSentService,
  SupabaseMomentsUpcomingService,
} from "../../../modules/moment/server/supabase-moment-service";
import { useFlag } from "../../../server/optimizely";
import { useSupabase } from "../../../server/supabase/hooks";
import { MomentCarousels } from "./moment-carousels";

const MomentsDashboardPage = (): ReactElement => {
  const [recentlyEdited, setRecentlyEdited] = useState<MomentCardMomentActivity[]>();
  const [sent, setSent] = useState<MomentCardMomentActivity[]>();
  const [upcoming, setUpcoming] = useState<MomentCardMomentActivity[]>();

  const limit = 24;

  useSupabase(({ supabase, account_id }) => {
    return new SupabaseMomentsRecentlyEditedService(supabase)
      .getAllMoments(account_id, { limit, order: [{ column: "attime", dir: "desc" }] })
      .then(({ data, error }) => {
        if (!error) {
          setRecentlyEdited(data);
        }
      });
  }, []);

  useSupabase(({ supabase, account_id }) => {
    return new SupabaseMomentsSentService(supabase)
      .getAllMoments(account_id, { limit, order: [{ column: "attime", dir: "desc" }] })
      .then(({ data, error }) => {
        if (!error) {
          setSent(data);
        }
      });
  }, []);

  useSupabase(({ supabase, account_id }) => {
    return new SupabaseMomentsUpcomingService(supabase)
      .getAllMoments(account_id, { limit, order: [{ column: "attime", dir: "asc" }] })
      .then(({ data, error }) => {
        if (!error) {
          setUpcoming(data);
        }
      });
  }, []);

  return <MomentsDashboard recentlyEdited={recentlyEdited} sent={sent} upcoming={upcoming} />;
};

const MomentsDashboard: FC<{
  recentlyEdited?: MomentCardMomentActivity[];
  sent?: MomentCardMomentActivity[];
  upcoming?: MomentCardMomentActivity[];
}> = ({ recentlyEdited, sent, upcoming }) => {
  const [additional_services, , flagLoaded] = useFlag("additional_services");
  const { t } = useTranslation();

  return (
    <Page title={t("Your Communications | ChangeEngine")}>
      <CreateAIContentCarousel />
      {flagLoaded && (
        <>
          {additional_services && <AdditionalServicesCarousel />}
          <PageContent>
            <MomentCarousels recentlyEdited={recentlyEdited} sent={sent} upcoming={upcoming} />
          </PageContent>
        </>
      )}
    </Page>
  );
};
export default MomentsDashboardPage;
